module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/f0001-01.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('a', {
    attrs: {
      "id": "page_2"
    }
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/f0002-01.jpg"
    }
  })])]), _c('a', {
    attrs: {
      "id": "page_2"
    }
  }), _c('h1', {
    staticClass: "h1"
  }, [_c('a', {
    attrs: {
      "id": "page_2"
    }
  }), _c('a', {
    attrs: {
      "id": "page_3"
    }
  }), _c('a', {
    attrs: {
      "id": "title"
    }
  }, [_vm._v("Sticky, Chewy, Messy, Gooey")])]), _c('a', {
    attrs: {
      "id": "title"
    }
  }, [_c('p', {
    staticClass: "subtitle"
  }, [_c('strong', [_vm._v("DESSERTS FOR THE SERIOUS SWEET TOOTH")])]), _vm._v(" "), _c('p', {
    staticClass: "author"
  }, [_c('strong', [_vm._v("By Jill O’Connor")])]), _vm._v(" "), _c('p', {
    staticClass: "author"
  }, [_c('span', {
    staticClass: "small"
  }, [_c('strong', [_vm._v("PHOTOGRAPHS BY LEIGH BEISCH")])])]), _vm._v(" "), _c('p', {
    staticClass: "publisher"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/pub.jpg"
    }
  })])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-487ef182","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/ch00a_title.vue
// module id = 63
// module chunks = 0